// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VeeValidate from 'vee-validate'
import messages from '@/messages'
import App from './App'
import router from '@/router/router'
import filters from './filters'
import { store } from './store/store.js'
import 'bootstrap'
import 'font-awesome/css/font-awesome.css'

Vue.use(VeeValidate)
Vue.use(VueI18n)
Vue.config.productionTip = false
document.addEventListener('DOMContentLoaded', function () {
  var comment = document.createComment('[START APP GIT COMMIT HASH] - ' + process.env.VUE_APP_GIT_HASH + ' ')
  document.insertBefore(comment, document.firstChild)
})
for (let name in filters) {
  Vue.filter(name, filters[name])
}
const i18n = new VueI18n({
  locale: 'en-US',
  fallbackLocale: 'en-US',
  messages
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
